import { OtherUserPanelCSS } from './OtherUserPanelCSS.styled'
import { UserOverview } from 'components/Molecules/userProfileOverview/UserOverview'

export const OtherUserPanel = (props) => {
  return (
    <OtherUserPanelCSS>
      <div className='user_tabs_wrapper'>
        <div className='user_panels'>
          <div className='sections_wrapper'>
            <div className='user_tabs_panel' id='user-overview_panel'>
              <UserOverview {...props} />
            </div>
          </div>
        </div>
      </div>
    </OtherUserPanelCSS>
  )
}
